import differenceWith from "lodash/fp/differenceWith";
import isEqual from "lodash/fp/isEqual";
import classNames from "classnames";
import { LocalStorage } from "../../models/LocalStorage";
import { apiGetIpConfig } from "../../utils/api";
import { setupLanguage } from "../../utils/language";
import { replaceVariable } from "../../utils/string";
import { convertShippingList, getCurrencyCodeByCountry } from "../../utils/country";
import { convertCurrencyList } from "../../utils/currency";
import { DComponent } from "../DComponent";
import FilterForm from "../FilterForm";
import { defer } from "../../utils/script";
import { callEvent, listenEvent, EVENTS } from "../../utils/event";
import { SettingConfig } from "../../models/SettingConfig";
import { DCStatic } from "../../models/DCStatic";

export default class ModalPicker extends DComponent {
  constructor({
    parent,
    id,
    hideShipping,
    hideCurrency,
    curLanguage,
    curShipping,
    curCurrency,
    shippingList = [],
    currencyList = [],
    onEvent = {},
    fixedMetaLang,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("ModalPicker"),
      classShipping: hideShipping ? " hide" : "",
      classCurrency: hideCurrency ? " hide" : "",
    });
    this.hideShipping = hideShipping;
    this.hideCurrency = hideCurrency;
    this.curLanguage = curLanguage;
    this.curShipping = curShipping;
    this.curCurrency = curCurrency;
    this.shippingList = shippingList;
    this.currencyList = currencyList;
    this.onEvent = onEvent;
    this.fixedMetaLang = fixedMetaLang;
    /** @type {FilterForm} */
    this.shippingSelect = undefined;
    /** @type {FilterForm} */
    this.currencySelect = undefined;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "ModalPicker");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    if (this.curLanguage) this.onLanguage(this.curLanguage);

    this.currencySelect = new FilterForm({
      parent: $(".select-currency", this.element),
      inline: true, hideFeedback: true,
      placeholderI18n: "header_currencySelect",
      options: this.getOptionCurrency(this.currencyList, this.curCurrency),
      currentValue: this.curCurrency,
    })

    this.shippingSelect = new FilterForm({
      parent: $(".select-shipping", this.element),
      inline: true, hideFeedback: true,
      placeholderI18n: "header_shippingSelect",
      onChange: (val) => this.onChangeShipping(val),
      options: this.getOptionShipping(this.shippingList, this.curShipping),
      currentValue: this.curShipping,
    })

    $("body").on("click", ".ModalPicker .group-select:not(.disabled) .item-radio", (e) => {
      $(e.currentTarget).parent().find(".radio").removeClass("active");
      $(e.currentTarget).find(".radio").addClass("active");
      if ($(e.currentTarget).parent().attr("data-type") === "language") {
        let newLang = $(e.currentTarget).find(".radio").attr("data-id");
        if (newLang !== window.tempLang) {
          window.tempLang = newLang;
          $(".group-select", this.element).attr("data-lang", newLang);
          this.shippingSelect.setLang(newLang, true);
          this.currencySelect.setLang(newLang);
          $.i18n({
            locale: newLang,
          });
          this.update();
        }
      }
    });

    this.element.on("shown.bs.modal", () => {
      let newLang = LocalStorage.getLanguage() || "vi";
      $(".group-select", this.element).attr("data-lang", newLang);
      $.i18n({
        locale: newLang,
      });
      if (newLang !== window.tempLang) {
        window.tempLang = newLang;
        this.shippingSelect.setLang(newLang, true);
        this.currencySelect.setLang(newLang);
      }
      this.update();

      if (!this.hideShipping || !this.hideCurrency) {
        this.getIpConfig();
      }
    });

    this.element.on("hide.bs.modal", () => {
      $("html, body").css("overflow", "auto");
      this.onLanguage(this.curLanguage);
      this.onShipping(this.curShipping);
      this.onCurrency(this.curCurrency);
    })

    $(".btn-apply", this.element).on("click", () => {
      let params = {};
      let newLang = $(`.group-radio[data-type=language] .item-radio .radio.active`, this.element).data("id");
      if (newLang && newLang !== this.curLanguage) {
        LocalStorage.setLanguage(newLang);
        DCStatic.locale = newLang;
        setupLanguage(undefined, false, this.fixedMetaLang);
        typeof this.onEvent.onLanguage === "function" && this.onEvent.onLanguage(newLang);
        params.language = newLang;
        callEvent(EVENTS.CHANGE_LANGUAGE, newLang);
      }

      let newShip = this.shippingSelect.getValue();
      if (newShip && newShip !== this.curShipping) {
        LocalStorage.setShipping(newShip)
        DCStatic.shippingCountry = newShip;
        typeof this.onEvent.onShipping === "function" && this.onEvent.onShipping(newShip);
        params.shipping = newShip;
        callEvent(EVENTS.CHANGE_COUNTRY, newShip);
      }

      let newCur = this.currencySelect.getValue();
      if (newCur && newCur !== this.curCurrency) {
        params.currencyOld = this.curCurrency;
        LocalStorage.setCurrency(newCur)
        DCStatic.currency = newCur;
        typeof this.onEvent.onCurrency === "function" && this.onEvent.onCurrency(newCur);
        params.currency = newCur;
        callEvent(EVENTS.CHANGE_CURRENCY, newCur);
      }

      if (Object.keys(params).length) {
        typeof this.onEvent.onChange === "function" && this.onEvent.onChange(params);
        callEvent(EVENTS.CHANGE_SETTING);
      }

      this.hide();
    });

    listenEvent(EVENTS.MINI_APP_CHANGE_LANGUAGE, (e) => {
      setupLanguage(undefined, false, this.fixedMetaLang);
      this.onLanguage(LocalStorage.getLanguage());
      typeof this.onEvent.onLanguage === "function" && this.onEvent.onLanguage(LocalStorage.getLanguage());
    });

    listenEvent(EVENTS.MINI_APP_CHANGE_SHIPPING_COUNTRY, (e) => {
      typeof this.onEvent.onShipping === "function" && this.onEvent.onShipping(LocalStorage.getShipping());
      this.onShipping(LocalStorage.getShipping(), true);
    });

    listenEvent(EVENTS.MINI_APP_CHANGE_CURRENCY, (e) => {
      typeof this.onEvent.onCurrency === "function" && this.onEvent.onCurrency(LocalStorage.getCurrency());
      this.onCurrency(LocalStorage.getCurrency(), true);
    });

    listenEvent(EVENTS.CHANGE_LANGUAGE, (data) => {
      this.onLanguage(data);
    })

    listenEvent(EVENTS.CHANGE_COUNTRY, (data) => {
      this.onShipping(data, true);
    })

    listenEvent(EVENTS.CHANGE_CURRENCY, (data) => {
      this.onCurrency(data, true);
    })
  }


  getIpConfig() {
    apiGetIpConfig(
      (data) => {
        $(".group-select.currency", this.element).addClass("hide");
        $(".group-select.shipping", this.element).addClass("hide");
        if (data) {
          let setting = SettingConfig.fromApiObject(data);
          DCStatic.handleSettingConfig(setting);

          if (DCStatic.shippingTo?.length > 0) {
            if (!this.hideShipping) {
              if (differenceWith(this.shippingList, DCStatic.shippingTo, isEqual).length) {
                this.shippingList = DCStatic.shippingTo;
                this.addOptionShipping(DCStatic.shippingTo, DCStatic.shippingCountry);
              }
              $(".group-select.shipping", this.element).removeClass("hide");
            }
            if (DCStatic.shippingCountry !== this.curShipping) {
              typeof this.onEvent.onShipping == "function" && this.onEvent.onShipping(DCStatic.shippingCountry);
              callEvent(EVENTS.CHANGE_COUNTRY, DCStatic.shippingCountry);
            }
          }

          if (DCStatic.currencies?.length > 0) {
            if (!this.hideCurrency) {
              if (differenceWith(this.currencyList, DCStatic.currencies, isEqual).length) {
                this.currencyList = DCStatic.currencies;
                this.addOptionCurrency(DCStatic.currencies, DCStatic.currency);
              }
              $(".group-select.currency", this.element).removeClass("hide");
            }
            if (DCStatic.currency !== this.curCurrency) {
              typeof this.onEvent.onCurrency == "function" && this.onEvent.onCurrency(DCStatic.currency);
              callEvent(EVENTS.CHANGE_CURRENCY, DCStatic.currency);
            }
          }
          const defaultLanguage = DCStatic.locale;
          if (defaultLanguage !== this.curLanguage) {
            typeof this.onEvent.onLanguage == "function" && this.onEvent.onLanguage(defaultLanguage);
            callEvent(EVENTS.CHANGE_LANGUAGE, defaultLanguage);
          }
        }
      },
      () => {
        $(".group-select.currency", this.element).addClass("hide");
        $(".group-select.shipping", this.element).addClass("hide");
      }
    )
  }

  onChangeShipping(val) {
    let tempCurrency = getCurrencyCodeByCountry(val) || "USD";
    this.currencySelect.setValue(tempCurrency);
  }

  /** @param {ModalPicker} _params */
  updateAttributes(_params = {}) {
    defer(() => this.element, () => {
      Object.keys(_params).forEach(key => {
        this[key] = _params[key];
      });
    });
  }

  init() { }

  show() {
    $("html, body").css("overflow", "hidden");
    this.element.modal("show");
  }

  hide() {
    this.element.modal("hide");
  }

  genGroupPicker(selector, list, curValue) {
    let htmlResult = "";
    list.forEach(element => {
      htmlResult += replaceVariable(require("html-loader!./item.html"), {
        class: element.value === curValue ? " active" : "",
        lang: LocalStorage.getLanguage() || "vi",
        value: element.value,
        label: element.label,
        label_vi: element.label_vi || element.label
      })
    });

    selector.html(htmlResult);
  }

  onLanguage(newLang) {
    this.curLanguage = newLang;
    this.setActivePicker("language", newLang);
  }

  onShipping(newShip, trigger = true) {
    this.curShipping = newShip;
    this.shippingSelect.setValue(newShip, trigger);
  }

  onCurrency(newCurrency, trigger = true) {
    this.curCurrency = newCurrency;
    this.currencySelect.setValue(newCurrency, trigger);
  }

  onDisabled(type, isDisable) {
    switch (type) {
      case "shipping":
        defer(() => this.shippingSelect, () => { this.shippingSelect.setDisabled(isDisable); });
        break;
      case "currency":
        defer(() => this.currencySelect, () => { this.currencySelect.setDisabled(isDisable); });
        break;
      default:
        isDisable ? $(".group-select." + type, this.element).addClass("disabled") : $(".group-select." + type, this.element).removeClass("disabled");
        break;
    }
  }

  setActivePicker(type, value) {
    $(`.group-radio[data-type=${type}] .item-radio .radio`, this.element).removeClass("active");
    $(`.group-radio[data-type=${type}] .item-radio .radio[data-id=${value}]`, this.element).addClass("active");
  }

  addOptionShipping(shippingList, shipping) {
    this.shippingSelect.addOption(this.getOptionShipping(shippingList, shipping));
  }

  addOptionCurrency(currencyList, currency) {
    this.currencySelect.addOption(this.getOptionCurrency(currencyList, currency));
  }

  getOptionShipping(shippingList = [], shipping) {
    if (!shippingList?.length) return [];
    return convertShippingList(shippingList, shipping);
  }

  getOptionCurrency(currencyList = [], currency) {
    if (!currencyList?.length) return [];
    return convertCurrencyList(currencyList, currency);
  }
}